import { create } from 'zustand';
import { Actions, State } from '../types';

export const TOTAL_STEPS = [1, 2, 3];

export const useGiftFinderStore = create<State & Actions>((set) => ({
  currentStep: 1,
  activeItemIndex: null,
  selectedFilters: {},

  setCurrentStep: (step) => set({ currentStep: step }),
  setActiveItemIndex: (index) => set({ activeItemIndex: index }),
  setSelectedFilter: (step, filterValue) =>
    set((state) => ({
      selectedFilters: {
        ...state.selectedFilters,
        [step]: filterValue,
      },
    })),
}));
